import { ContentFull, ContentHeader, ContentSubheader } from "components/layout";
import React from "react";
import { ActivityTypeEditor, activityTypesDescription } from "./activity-type-editor";
import { AgencyTogglePref } from "./agency-settings-toggle";

export const AgencySettingsTasks: React.FC<unknown> = () => {
    return (
        <>
            <ContentFull>
                <ContentHeader>Task Settings</ContentHeader>
                <AgencyTogglePref
                    field="alertClientsWithNoTasks"
                    label="Require active tasks for every client"
                    description="When enabled, you will be alerted when trying to leave a client that has no active tasks. This can help ensure every client is receiving the attention they need."
                />
            </ContentFull>
            <ContentFull className="mt-4">
                <ContentHeader>Activity Types</ContentHeader>
                <ContentSubheader>{activityTypesDescription}</ContentSubheader>
                <ActivityTypeEditor scope={{ kind: "agencyWide" }} disabled={false} />
            </ContentFull>
        </>
    );
};
